const initialState = {
    loading:false,
    consents:[],
};

export function fetchPolicyDocument(state = initialState, action) {
    switch (action.type) {
        case 'FETCH.POLICY_DOCUMENT.SUCCESS':
            return {
                ...state,
                ...action.response,
            };
        case 'ADD.POLICY_DOCUMENT_CONSENT.SUCCESS':
            const consent = action.params;
            const {consents} = state;
            const filteredConsents = consents.filter(c=>c.id !== consent.id);

            const newState = {
                ...state,
                consents: [...filteredConsents, consent]
            };
            return newState;

        default:
            return state
    }
}
